export default __webpack_public_path__ + "static/media/screen9.fecf08ea.png";